var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/calendar-days",
    clipPath: "url(#clip0_9411_21790)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33333 1.49023V4.1569M10.6667 1.49023V4.1569M2 6.82357H14M5.33333 9.49023H5.34M8 9.49023H8.00667M10.6667 9.49023H10.6733M5.33333 12.1569H5.34M8 12.1569H8.00667M10.6667 12.1569H10.6733M3.33333 2.82357H12.6667C13.403 2.82357 14 3.42052 14 4.1569V13.4902C14 14.2266 13.403 14.8236 12.6667 14.8236H3.33333C2.59695 14.8236 2 14.2266 2 13.4902V4.1569C2 3.42052 2.59695 2.82357 3.33333 2.82357Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9411_21790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.157227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a6ca924749032fc3f02ecc69678479a1.svg";
export { ForwardRef as ReactComponent };